import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${({ isRow }) =>
    isRow &&
    `
    align-items: center;
    justify-content: center;
  `}
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
`;

export const CurrencySign = styled.span`
  display: flex;
  align-items: center;
  line-height: 1;
  color: ${COLOR.darkBlue};
  font-size: 16px;
  font-weight: 510;
  ${({ isVietnam }) => isVietnam && 'text-decoration: underline;'}
  ${({ isRow }) => isRow && 'font-size: 20px;'}
`;

export const PriceMain = styled.span`
  font-weight: 800;
  color: ${COLOR.darkBlue};
  font-size: 32px;
  line-height: 32px;
`;

export const PriceSub = styled.span`
  margin-right: 6px;
  font-weight: 800;
  font-size: 20px;
  color: ${COLOR.darkBlue};
`;

export const PerYear = styled.span`
  font-size: 14px;
  color: rgba(28, 28, 30, 0.64);
  ${({ isRow }) => isRow && 'font-size: 20px;'}
`;

export const DiscountRow = styled.div`
  display: flex;
  height: 25px;
  align-items: center;
`;

export const OriginalCurrencySign = styled.span`
  color: rgba(0, 0, 0, 0.48);
  font-size: 14px;
  font-weight: 400;
  ${({ isVietnam }) => isVietnam && 'text-decoration: underline;'}
  ${({ isRow }) => isRow && 'font-size: 16px;'}
`;

export const OriginalPriceText = styled.span`
  text-decoration: line-through;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.48);
  font-size: 14px;
  ${({ isRow }) => isRow && 'font-size: 16px;'}
`;

export const OriginalPerYear = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.48);
  ${({ isRow }) => isRow && 'font-size: 16px;'}
`;

export const EmptyDiscount = styled.div`
  height: 25px;
`;
